import {
    dataAtual,
} from '../../../business-components/Date/Date'

import {
    sortDesc
} from '../../../business-components/Sort/Sort'



export const incrementaContFunisEtapas = ( values ) => {

    if (!values.contFunisEtapas) {
        
        values.contFunisEtapas = 0
    }

    values.contFunisEtapas += 1
}



export const incluirFunisEtapas = (values) => {
        
    incrementaContFunisEtapas(values)

    values.funisEtapas.push(
        {
            id: values.contFunisEtapas,
            funil: values.funil,
            etapa: values.etapa,
            dataHoraPrevistaFunilEtapa: values.dataHoraPrevistaFunilEtapa,
            dataRealizacaoFunilEtapa: values.dataRealizacaoFunilEtapa,
            ordem: values.contFunisEtapas,
            dataHoraInclusao: dataAtual(),
        }
    )

    values.funisEtapas = sortDesc(values.funisEtapas)

    values.etapaAnt = values.etapa
}